<p [style.display]="(listInfo.pageData.length === 0) ? 'block' : 'none'" class="no-results-message"><span *ngIf="listInfo.totalRecords === 0">No practitioner found to match your filter criteria. </span>Credentialed practitioners may opt-out from this listing. If you believe the person you are searching for is credentialed, please contact our office by phone at 913.895.4900 for verification.
</p>
<div [style.display]="(listInfo.pageData.length > 0) ? 'block' : 'none'" class="practitioner-items" >
  <div class="practitioner-item" *ngFor="let item of listInfo.pageData; let i = index" style="position: relative;" id="{{i}}"><!--style="white-space: pre-line;"-->
    
    <h3 class="practitioner-item__name" >{{item.activeDirectoryItem.lastName}}, <span *ngIf="item.activeDirectoryItem.suffix">{{item.activeDirectoryItem.suffix}}, </span> {{item.activeDirectoryItem.firstName}}
      {{ (item.activeDirectoryItem.middleName && item.activeDirectoryItem.middleName.length === 1) ? (item.activeDirectoryItem.middleName + ".").replace("..",".") :
       item.activeDirectoryItem.middleName ? item.activeDirectoryItem.middleName : ''}}
    </h3>    
    <table class="credential-summary-table">
    <thead>
    <tr class="credential-summary-table__header-row">
    <th>Credential</th>
    <th>Valid Thru</th>
    </tr>
    </thead>
    <tbody>
    <tr class="credential-summary" *ngFor="let certification of item.activeDirectoryItem.certifications">
    <td class="credential-summary__name">{{baseCredential(item.activeDirectoryItem.baseCredential, certification.credentialCode)}}{{certification.credentialCode}}</td>
    <td [class.red]="certification.isExpired" class="credential-summary__expiration-date">{{certification.expirationDate | amDateFormat:"L"}}<div style="padding-left: 100px" *ngIf="!certification.expirationDate">N/A*</div></td>
    </tr>
    </tbody>
    <div *ngIf="item.activeDirectoryItem.provisional" style="color:red;">
      Expiration provisionally extended to 12/31/2020 due to COVID-19 pandemic and will revert to expired status on 1/1/2021.
    </div>

  </table>
    <div class="on-print"><p>Credentialing information provided by the NBRC (electronic, verbal, written or otherwise) is considered primary source verification.</p></div>
    <div class="on-print"><p>Requested on {{currentDate}}</p></div>
     <button id="print" class="print-btn button button--bare button--bare-alt no-print" (click)="printSection(i)" *ngIf="listInfo.pageData.length !== 0 && hideAddress">
      <i class="button__icon icon icon--print"></i>
      <span class="button__text">Print</span>
    </button>
    <button id="orderCV" class="button button--bare button--bare-alt no-print" (click)="orderCV(item.activeDirectoryItem)" *ngIf="listInfo.pageData.length !== 0 && hideAddress">
      <i class="button__icon icon icon--credit-card"></i>
      <span class="button__text">Order Credential Verification</span>
    </button>    
    <button *ngIf="!hideAddress && item.activeDirectoryItem.line1" (click)="onShowAddressClick(item)" class="no-print button button--bare button--bare-alt practitioner-item__address-toggle-button">{{item.showAddress ?
      "Hide Address" : "Show Address"}}
    </button>
    <div *ngIf="item.showAddress && item.activeDirectoryItem.line1" class="practitioner-item__address ">
      <div *ngIf="item.activeDirectoryItem.line1">{{item.activeDirectoryItem.line1}}</div>
      <div *ngIf="item.activeDirectoryItem.line2">{{item.activeDirectoryItem.line2}}</div>
      <div *ngIf="item.activeDirectoryItem.line3">{{item.activeDirectoryItem.line3}}</div>
      <div>{{item.activeDirectoryItem.city}} {{item.activeDirectoryItem.stateProvince}}, {{item.activeDirectoryItem.zip}}
      </div>
    </div>
  </div>  
</div>
<app-directory-list-paging [style.display]="(pageCount > 1) ? 'block' : 'none'" [currentPage]="listInfo.pageNumber" [totalPages]="pageCount" (pageClick)="pageChanged($event)"></app-directory-list-paging>
<iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank">  
</iframe>

<style>
.red{ color:red; }
.print-btn{
  position: absolute;
  left: 0;
  bottom: 0;
  margin: 0 0 15px 15px;
}
.practitioner-item__name, .credential-summary-table{
  width:100%;
}
</style>